import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Row, Col, Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { getLocalStorageItems } from "../../utils/functions/functionsUtils";
import { GetInternalPagesByType } from "../../services/internal.service";
import { LoadPanel, ScrollView } from "devextreme-react";
import React from "react";

const PageTitle = styled.h1`
  font-size: 25px;
  margin-top: 15px;
`;

const MainContainer = styled.div`
  padding-top: 20px;
  width: 100%;
`;

const SpanContent = styled.span`
  font-size: medium;
`;

function Gdpr({ hasScroll = true }: { hasScroll: boolean }) {
  //Translation module
  const { t, i18n } = useTranslation();
  //*******************
  const [internalPage, setInternalPage] = useState<string>("");
  const [isLoading, setisLoading] = useState(false);
  const [langChanged, setlangChanged] = useState(false);

  //*******************
  const i18nextLng = getLocalStorageItems("i18nextLng", false);

  const GetInternalPageData = () => {
    setisLoading(true);
    setlangChanged(false);

    GetInternalPagesByType("gdpr")
      .then((response) => {
        setisLoading(false);
        const currentLangVAlues = response.find((x) => {
          if (i18nextLng === "GB" && x.language === "EN") {
            return x;
          } else {
            return x.language === i18nextLng;
          }
        })?.content;

        if (currentLangVAlues) {
          setInternalPage(currentLangVAlues);
        }
      })
      .catch(() => {
        setisLoading(false);
        setlangChanged(false);
      });
  };

  useEffect(() => {
    GetInternalPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    i18n.on("languageChanged", () => {
      setlangChanged(true);
    });

    if (langChanged) GetInternalPageData();

    return () => {
      i18n.off("languageChanged");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [langChanged]);

  const mainContent = () => {
    return (
      <MainContainer className="wysiwyg">
        <Container>
          <Row>
            <Col>
              <PageTitle>{t("RGPD")}</PageTitle>
              <SpanContent>
                <div
                  dangerouslySetInnerHTML={{
                    __html: internalPage,
                  }}
                ></div>
              </SpanContent>
            </Col>
          </Row>
        </Container>
        <LoadPanel
          visible={isLoading}
          showIndicator={true}
          shading={true}
          shadingColor="rgba(0,0,0,0.4)"
          showPane={false}
          position={{ of: "#main-container-wrapper" }}
          message={t("LoadingData")!}
        />
      </MainContainer>
    );
  };
  return hasScroll ? (
    <ScrollView height={window.innerHeight - 150} direction="vertical">
      {mainContent()}
    </ScrollView>
  ) : (
    mainContent()
  );
}

export default Gdpr;
